// extracted by mini-css-extract-plugin
module.exports = {"money":"styles_money__1UCSr"};